import ReportValue from "@frameworks/web/components/generic/commonTableVal";
import React from "react";
var StockChange = function (props) {
    return (React.createElement("div", { className: "RobotoR_14_400" },
        React.createElement(ReportValue, { val: props.change, stream: true, onlyval: true, notRoundBracket: true }),
        React.createElement(ReportValue, { val: props.changePerc, stream: true, onlyval: true, percentage: true })));
};
export default StockChange;
